import type { UserFlagsDisplayFlag } from '@xing-com/crate-common-graphql-types';
import type { FlagVariant } from '@xing-com/flag';

export const displayFlagMap = (
  displayFlag?: UserFlagsDisplayFlag | null
): FlagVariant | undefined => {
  switch (displayFlag) {
    /** A user with ambassador role */
    case 'AMBASSADOR':
      return 'ambassador';
    /** A user with insider role */
    case 'INSIDER':
      return 'insider';
    /** A user with ProTrainer membership */
    case 'PRO_TRAINER':
      return 'proTrainer';
    /** A user with ProCoach membership */
    case 'PRO_COACH':
      return 'proCoach';
    /** A user with moderator role */
    case 'MODERATOR':
      return 'moderator';
    /** A user with premium membership */
    case 'PREMIUM':
      return 'premium';
    /** A user with basic membership */
    case 'BASIC':
      return 'basic';
    /** Default user role and membership */
    default:
      return undefined;
  }
};
